import React from "react";
import styled from "styled-components";
import { deviceSize } from "../../components/responsive";
import { Link } from "react-router-dom";

//MiddleSectionContainer
const MsC = styled.div`
  width: 100%;
  height: 900px;
  background: linear-gradient(to bottom, #fcfcfb 2%, #ffffff 30%);

  @media screen and (max-width: 768px) {
    /* margin-top: 20%; */
    height: auto;
    margin-bottom: 0;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const LinkAc = styled(Link)`
  color: blue;
`;

const ContextContianer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding-top: 5%;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 0px;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    flex-direction: column;
    height: 100%;
  
  }
`;

const QtHt = styled.h3`
  font-family: "Roboto";
  font-style: bold;
  font-weight: 500;
  font-size: 28px;
  line-height: 33px;
  text-align: left;
  width: 60%;
  color: #9d2222;
  margin-left: 10%;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 90%;
    margin-right: 3%;
    margin-left: 0px;
  }

  @media screen and (max-width: 768px) {
    font-size: 16px;
    width: 100%;
    text-align: center;
  }
`;

//AboutRow
const Ar = styled.div`
  display: flex;
  align-items: flex-start;
  grid-template-areas: "col2 col1";
  margin-top: 40px;
  margin-left: 10%;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 0;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    grid-template-areas: "col1 col1" "col2 col2";
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: 768px) {
    grid-template-areas: "col1 col1" "col2 col2";
    display: flex;
    flex-direction: column;
    padding: 7%;
    width: 100%;
  }
`;

const Column1 = styled.div`
  margin-bottom: 15px;
  grid-area: col2;

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-left: 0%;
  }
`;

//textwrappper
const Tw = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

const Subtitle = styled.p`
  font-family: "Sunflower";
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 30px;
  color: #282828;
  text-align: left;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 13px;
  }
`;

export function MiddleSectionContactUs() {
  return (
    <MsC id="msc">
      <ContextContianer>
        <QtHt>Availability is the best ability.</QtHt>
        <Ar id="ar">
          <Column1>
            <Tw>
              <Subtitle>
                Expedient is not immune to the realities of COVID-19. In order
                to help New Yorkers cope with the pandemic via the{" "}
                <LinkAc to="">GetFoodNYC program</LinkAc>, we had to ensure the
                availability of our call agents. To do that, we had to ensure
                the health and safety of our call agents.
              </Subtitle>

              <Subtitle>
                Proactive adoption of the above policies successfully protected
                Expedient’s essential workers from COVID-19 exposure. This
                initiative also kept the company compliant with the{" "}
                <a
                  href={
                    "https://dol.ny.gov/ny-hero-act#:~:text=The%20purpose%20of%20the%20NY,disease%20under%20the%20HERO%20Act"
                  }
                >
                  {" "}
                  NY State Hero Act
                </a>
                —far before it was put into law.
              </Subtitle>

              <Subtitle>
                These policies, drafted and deployed in-house, limited COVID
                exposure within the office, kept employees and their families
                safe, and kept Expedient on the front lines helping our
                neighbors navigate the pandemic.
              </Subtitle>

              <Subtitle>
                If you’re looking to keep your workplace safe, or returning
                employees to the office, Expedient can implement structure that
                helps you sleep soundly. Our compliance SMEs are health and
                safety specialists that ensure your staff the ability to work
                safely together.
              </Subtitle>
            </Tw>
          </Column1>
        </Ar>
      </ContextContianer>
    </MsC>
  );
}
